var isPage = "";
let Animate = {
	top: 0,
	show: 0
}
let checkTimer;
let animations = [];
var common = {
	beforeW: 0,
	topD: 0,
	isIPad: false,
	init: ()=>{
		framework.init();
		var resizeFlag;
		var resizeTimer = null;
		var $body = $("body");

		common.resize();
		common.nav();
		common.initScroll();
		checkTimer = setInterval(function(){
			common.checkPosition()
		}, 200);
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};

		$(window).off("resize").on("resize",function(){
			if(!$body.hasClass("resize")){
				$body.addClass("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
	},
	initScroll: function(){
		let topD, btmD, scrollTimeId;
		//console.log(common.isIPad, $html.classList.contains("iPad"))
		if(isSP || common.isIPad || $html.classList.contains("iPad")){
			$(document).off("scroll touchmove").on("scroll touchmove", function(){
				spScroll();
			});
		}else{
			scrollbar.removeListener(null);
			scrollbar.addListener((listener) =>{
				clearTimeout(scrollTimeId);
				common.topD = listener.offset.y;
				topD = listener.offset.y;
				btmD = topD + window.innerHeight;
				common.scrl(topD, btmD);
				
				scrollTimeId = setTimeout( function () {
				}, 200 ) ;
			});
		}
		function spScroll(){
			topD 		= $(document).scrollTop();
			common.topD = topD;
			btmD 		= topD + window.innerHeight;
			common.scrl(topD, btmD);
		}
	},
	nav: ()=>{
		shareSNS.nav();
	},
	checkScrollPostiion: function(){
		let prop = location.search;
		if(prop){
			prop = prop.substring(1);
			var parameters = prop.split('&');
			
			for (var i = 0; i < parameters.length; i++) {
				var element = parameters[i].split('=');
				
				var name = decodeURIComponent(element[0]);
				var val = decodeURIComponent(element[1]);
				if(name === "block"){
					let $block = $(`#block_${val}`);
					let headerH = $(".ttl_h1").offset().top + $(".ttl_h1").outerHeight();
					let posY;
					if( !isSP && !isIPad ){
						posY = Math.floor( $block.offset().top ) + common.topD - headerH;
					}else{
						posY = Math.floor( $block.offset().top ) - headerH;
					}
					common.scrollToPosByNum(posY);
				}
			}
		}
	},
	resize: ()=>{
		var winW = window.innerWidth;
		var winH = window.innerHeight;
		var $body = $("body");
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		addressbarH();
		//console.log(isSmallScreen, "resize", framework.folder);
		if(framework.folder === ""){
			$("#kv").css({
				"height": $(window).height() + "px"
			});
			if(winW != common.beforeW){
				if(!isSmallScreen){
					infiniteSlide.resize();
				}
			}
		}
		common.checkPosition();
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
		function addressbarH(){
			if(common.beforeW != winW){
				// 100vh、アドレスバーが出てる時に対応
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			}
		}
		common.beforeW = winW;
	},
	checkPosition: function(){
		animations = [];
		$(".a").each(function(){
			let _a 	= object(Animate);
			let isSlow = $(this).attr("data-show");
			if( isSP || common.isIPad || $html.classList.contains("iPad")){
				_a.top 	= Math.floor( $(this).offset().top );
			}else{
				_a.top 	= Math.floor( $(this).offset().top ) + common.topD;
				
			}
			if(isSlow === "slow"){
				_a.show = Math.floor( _a.top + window.innerHeight/2 );
			}else{
				_a.show = Math.floor( _a.top + window.innerHeight/4 );
			}
			
			_a.end = Math.floor( _a.show + window.innerHeight );
			animations.push(_a);
		});
		//console.log(animations);
	},
	scrollToPosByNum: function(posY){
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic";
		let duration = 1000;
	
		if( $(".scroll-content").length > 0 ){
			scrollbar.scrollTo(0, posY, duration,{});
		}else{
			$page.animate({
				scrollTop : posY + "px"
			},{
				"duration" 	: duration,
				"easing" 	: ease
			});
		}
	},
	makeIO: function(){
		for(var i = 0; i < ioArry.length; i++){
			let option = {
				root 		: null,
				rootMargin 	: ioArry[i].margin,
				threshold 	: ioArry[i].threshold
			}
			let element = $(ioArry[i].target)
			const io = new IntersectionObserver(ioArry[i].change, option);
			$.each(element, function(index, el){
				io.observe(el);
			});
		}
	},
	scrollToPosition: ($this) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic";
		let headerH = $(".ttl_h1").offset().top + $(".ttl_h1").outerHeight();
		let id = $this.attr("data-id");
		let posY = $("#" + id).offset().top - headerH;
		let duration = 1000;
	
		if( $(".scroll-content").length > 0 ){
			scrollbar.scrollTo(0, posY, duration,{});
		}else{
			$page.animate({
				scrollTop : posY + "px"
			},{
				"duration" 	: duration,
				"easing" 	: ease
			});
		}
	},
	scrollTo: function(posY){
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic";
		let duration = 10;
	
		if( $(".scroll-content").length > 0 ){
			scrollbar.scrollTo(0, posY, duration,{});
		}else{
			$page.animate({
				scrollTop : posY + "px"
			},{
				"duration" 	: duration,
				"easing" 	: ease
			});
		}
	},
	scrl: (topD, btmD) =>{
		var alen = animations.length;
		
		if( topD >= 100){
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled")
			}
		}else{
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled")
			}
		}
		for(var i = 0; i < alen; i++){
			if(btmD >= animations[i].show){
				activeAnimate(i);
			}
		}
		function activeAnimate(i){
			let $a = $(".a").eq(i);
			//project number
			if( $a.attr("data-num") && !$a.hasClass("animate")){
				let dnum = $a.attr("data-num");
				if( dnum.indexOf(".") > -1 ){
					
				}else{
					dnum = ("0000" + dnum).slice( -4 ) ;
					let dlen = dnum.length;
					for(let n = 0; n < dlen; n++){
						$a.find(".nums .n").eq(n).addClass("n" + dnum[n]);
					}
				}
			}
			
			if( !$a.hasClass("animate") ){
				$a.addClass("animate");
				setTimeout(function(){
					$a.addClass("animated");
				}, 1000);
			}
			
			//top
			if( $a.hasClass("img_project") && !$a.hasClass("complete")){
				let diff = btmD - animations[i].show;
				let clipP = 50 - ( 50 / (window.innerHeight/2) ) * diff;
				//console.log(diff, clipP);
				if(clipP < 0){ clipP = 0;}
				if(clipP === 0){
					if( !$a.hasClass("complete") ){
						$a.addClass("complete");
					}
				}
				$a.css({
					"clip-path": `inset(${clipP}% 0 0 0)`
				});
			}
		}
		//idea
		if( $("#back_to_project").length > 0 ){
			let btop = $("#back_to_project").offset().top;
			if(isSP || common.isIPad || $html.classList.contains("iPad")){
				
			}else{
				btop = btop + common.topD;
			}
			if(btmD >= btop){
				let h = $("#back_to_project").height();
				let diff = (btmD - btop);
				let t = -h + diff;
				if(t > 0){
					t = 0;
				}
				$("#back_to_project figure").css({
					"transform": `translate3d(0, ${t}px, 0)`
				});
			}
		}
		if( $(".img_mission").length > 0 ){
			let btop = $(".img_mission").offset().top;
			if(isSP || common.isIPad || $html.classList.contains("iPad")){
					
			}else{
				btop = btop + common.topD;
			}
			if(btmD >= btop){
				let h = $(".img_mission").outerHeight();
				let diff = h - $(".img_mission img").height();
				let p = diff/window.innerHeight;
				let t = p*(btmD - btop);
				if(t < diff){
					t = diff;
				}
				$(".img_mission img").css({
					"transform": `translate3d(0, ${t}px, 0)`
				});
			}
		}
	},
	mouseCursor: function(){
		window.document.addEventListener("mousemove", getMousePos, false);
		function getMousePos(e){
			mouse[0] = e.clientX;
			mouse[1] = e.clientY;
		}
	},
	sendGa: function(category, action, label){
		console.log(action, category, label);
		gtag('event', action, {
			'event_category': category,
			'event_label': label
		});
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	if($html.classList.contains("iPad")){
		common.isIPad = true;
	}
	common.init();
});